import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppSettingsService} from '../../services/app-settings.service';
import * as moment from 'jalali-moment';
import {DateMethods, Option, StaticMethods} from '../../model/GeneralModels';

@Component({
  selector: 'app-date-picker-field',
  template: `
    <div class="form-group">
      <div [formGroup]="date">
        <label>{{fieldLabel}}</label>
      </div>
      <div class="row col-12" style="margin-right: 1px !important;">
          <div class="col-4" style="margin-left: 5px !important;">
            <app-select-field [Group]="date" [fieldName]="'year'" [fieldLabel]="'سال'"
                              [options]="years" (OnChange)="onDateChange()"></app-select-field>
          </div>
          <br>
          <div class="col-4" style="margin-left: 5px;">
            <app-select-field [Group]="date" [fieldName]="'month'" [fieldLabel]="'ماه'"
                              [options]="months" (OnChange)="setDates(); onDateChange()"></app-select-field>
          </div>
          <br>
          <div class="col-4" style="margin-left: 5px;">
            <app-select-field [Group]="date" [fieldName]="'day'" [fieldLabel]="'روز'" (OnChange)="setDates(); onDateChange()"
                              [options]="days"></app-select-field>
          </div>
        </div>
      </div>
  `,
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/css/light.theme.css'
  ],
  styles: [`
  `]
})
export class CalenderFieldComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() AppSettings: AppSettingsService;
  @Input() fieldName: string;
  @Input() fieldLabel: string;
  @Input() options: any[];
  @Output() OnChange = new EventEmitter<File>();
  @Input() even: boolean;
  @Input() Icon: boolean;
  @Input() dateValue = '';
  @Input() viewList: any = {};
  @Input() maxAge = 70;
  @Input() minAge = 0;
  datePickerConfig: any;
  date = this.fb.group({
    year: ['', Validators.required],
    month: ['', Validators.required],
    day: ['', Validators.required],
  });
  //
  years: any[] = [];
  days: any[] = ['0'];
  months: Option[] = [];

  persianDate: any;

  constructor(private fb: FormBuilder, public settings: AppSettingsService) {
  }

  ngOnInit() {
    this.generateList();
  }

  generateList() {
    this.maxAge = this.maxAge || 70;
    this.minAge = this.minAge || 0;
    const today = DateMethods.getJalaliDate(new Date());
    const currentYear = parseInt(today.split('/')[0], 10);
    console.log('currentYear: ', currentYear);
    const maxYear = currentYear - this.maxAge;
    console.log('maxAge = ', this.maxAge);
    console.log('maxYear = ', maxYear);
    console.log('minAge = ', maxYear);
    const minYear = currentYear - this.minAge;
    console.log('min = ', minYear);
    this.setYears(maxYear, minYear);
    this.setMonths();
    this.setDates();
  }

  onChangeCallback(event) {
    this.OnChange.emit(event.target.selectedOptions.item(0).value);
  }

  onDateChange() {
    this.viewList[this.fieldName] = this.date.controls.year.value +
      '-' + this.date.controls.month.value + '-' + this.date.controls.day.value;
    if (this.date.valid) {
      this.Group.controls[this.fieldName].patchValue(
        DateMethods.getGeorgianDate(this.date.controls.year.value +
          '-' + this.date.controls.month.value + '-' + this.date.controls.day.value)
      );
    } else {
      this.Group.controls[this.fieldName].patchValue('');
    }
  }

  setYears(startY: number, endY: number) {
    this.years = [];
    let i = startY;
    console.log(i);
    console.log(endY);
    while (i <= endY) {
      this.years.push(i);
      i++;
      console.log(i);
    }
  }

  setMonths() {
    const listMonths = [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند'
    ];
    this.months = [];
    for (let i = 0, l = listMonths.length; i < l; i++) {
      this.months[this.months.length] = new Option(listMonths[i], i + 1);
    }
  }

  setDates() {
    const days = [];
    let maxDay = 0;
    console.log(this.date.value);
    if (this.date.controls.month.valid && this.date.controls.year.valid) {
      const monthNumber = parseInt(this.date.controls.month.value, 10);
      const yearNumber = parseInt(this.date.controls.year.value, 10);
      console.log(monthNumber, yearNumber);
      if (monthNumber > 0 && monthNumber < 6) {
        maxDay = 30;
      } else {
        if (monthNumber === 12) {
          if (yearNumber % 4 === 0) {
            maxDay = 30;
          } else {
            maxDay = 29;
          }
        } else {
          maxDay = 31;
        }
      }
      for (let i = 1; i <= maxDay; i++) {
        days[i - 1] = i + '';
      }
      console.log(days);
      this.days = days;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateList();
    if (this.dateValue) {
      if (changes.dateValue.currentValue && changes.dateValue.currentValue !== changes.dateValue.previousValue) {
        const persianDate = DateMethods.getJalaliDate(this.dateValue);
        console.log(persianDate);
        const year = persianDate.split('/')[0];
        const month = persianDate.split('/')[1];
        const day = persianDate.split('/')[2];
        console.log(year, month, day);
        this.date.controls.year.patchValue(year);
        this.setMonths();
        this.date.controls.month.patchValue(month);
        this.setDates();
        this.date.controls.day.patchValue(day);
        this.onChangeCallback(this.dateValue);
      }
    }
  }

}
